import { Channels } from 'services/campaign/types';

export enum TemplateType {
  OPENING_MESSAGE = 'OPENING_MESSAGE',
  WELCOME_MESSAGE = 'WELCOME_MESSAGE',
  RESTART_OPEN_MESSAGE = 'RESTART_OPEN_MESSAGE'
}

export type WhatsaapTemplate = {
  id: string;
  content: string;
  createdAt: string;
  updatedAt: string;
  variablesCount: number;
  organizationId?: string | null;
  mapping: {
    variable: string;
    key: string;
  }[];
  type?: TemplateType;
  channel: Channels;
};
